import SSOPage from './SSOPage';

export default SSOPage;